import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import LanguageSwitcher from '../pages/language-switcher/LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import { Language } from '../types/Language';
import { UserSetting } from '../types/UserSetting';

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (settingsObj: UserSetting) => void;
}

const SettingsModal: React.FC<Props> = ({ show, onClose, onSave }) => {
  const { t, i18n } = useTranslation();

  const LANGUAGE_OPTIONS: Language[] = [
    { key: 'en', name: 'English' },
    { key: 'he', name: 'עברית' }
  ];

  const [selectedLanguage, setSelectedLanguage] = useState<Language>(() => {
    const initialLang = LANGUAGE_OPTIONS.find(lang => lang.key === i18n.language);
    return initialLang || LANGUAGE_OPTIONS[0];
  });

  const handleSaveSettings = () => {
    i18n.changeLanguage(selectedLanguage.key); // <-- Apply selected language
    const settingObj = {
      language: selectedLanguage.key,
    };
    onSave(settingObj);
  };

  return (
    <Modal show={show} onHide={onClose} size="xl" centered backdrop="static" className="text-light" contentClassName="bg-dark">
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>{t('settings')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        <LanguageSwitcher
          currentLanguage={selectedLanguage}
          onLanguageChange={setSelectedLanguage}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button variant="primary" onClick={handleSaveSettings}>
          {t('save-changes')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SettingsModal;
